<div class="bg-white px-4 py-5 sm:px-6 border-b border-gray-200">
	<div *ngIf="card" class="flex space-x-3 items-center">
		<div class="min-w-0 flex-1">
			<p class="text-sm font-semibold text-gray-900">
				{{card.name}}
			</p>
			<p class="text-sm text-gray-500">
				Last updated: {{card.dateLastActivity | date:'MMM d, yyyy h:mm a'}}
			</p>
		</div>
		<div class="ml-4 flex flex-shrink-0">
			<!-- <button type="button" class="relative inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
				Share
			</button> -->
			<button (click)="modalCtrl.dismiss()" type="button" class="relative ml-3 inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
				Close
			</button>
		</div>
	</div>
</div>
<div class="overflow-y-scroll h-full">
	<div *ngIf="card.desc" class="px-6 py-4 border-b border-gray-200" >
		<div class="text-sm text-gray-700" [innerHTML]="card.desc | markdown">
		</div>
	</div>
	<div *ngFor="let checklist of card.checklists" class="px-6 py-4 border-b border-gray-200">
		<div class="text-sm text-gray-700 space-y-2">
			<div>
				<b>{{checklist.name}}:</b>
			</div>
			<div *ngFor="let item of checklist.checkItems" class="flex items-center">
				<ion-icon [name]="item.state === 'complete' ? 'checkbox' : 'square-outline'" class="mr-2"></ion-icon>
				{{item.name}}
			</div>
		</div>
	</div>
	<div *ngIf="comments[0]" class="h-full px-4 py-5">
		<div class="flow-root">
			<ul role="list">
				<li *ngFor="let comment of comments; let last = last">
					<div class="relative pb-8">
						<span *ngIf="!last" class="absolute left-5 top-5 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true"></span>
						<div class="relative flex items-start space-x-3">
							<div *ngIf="!comment.memberCreator.avatarUrl" class="relative px-1">
								<div class="flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 ring-8 ring-white">
									<svg class="h-5 w-5 text-gray-500" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
										<path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-5.5-2.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zM10 12a5.99 5.99 0 00-4.793 2.39A6.483 6.483 0 0010 16.5a6.483 6.483 0 004.793-2.11A5.99 5.99 0 0010 12z" clip-rule="evenodd" />
									</svg>
								</div>
							</div>
							<div *ngIf="comment.memberCreator.avatarUrl" class="relative px-1">
								<div class="flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 ring-8 ring-white">
									<div [style.background-image]="'url(' + comment.memberCreator.avatarUrl + '/50.png)'" class="h-full w-full bg-cover bg-center"></div>
								</div>
							</div>
							<div class="min-w-0 flex-1">
								<div>
									<div class="text-sm">
										<a href="#" class="font-medium text-gray-900">
											{{comment.memberCreator.fullName}}
										</a>
									</div>
									<p class="mt-0.5 text-xs text-gray-500">
										{{comment.date | date:'MMM d, yyyy h:mm a'}}
									</p>
								</div>
								<div class="mt-2 text-sm text-gray-700 pr-2" [innerHTML]="comment.data.text | markdown">
								</div>
							</div>
						</div>
					</div>
				</li>
			</ul>
		</div>
	</div>
</div>
